import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { filterApi, type Item } from "../react-query/api";
export function useAutocomplete(t0) {
  const $ = _c(10);
  const {
    inputValue,
    locale
  } = t0;
  let t1;
  let t2;
  if ($[0] !== inputValue || $[1] !== locale) {
    t1 = ["autocomplete", inputValue, locale];
    t2 = () => filterApi.fetchAutocomplete(inputValue, locale);
    $[0] = inputValue;
    $[1] = locale;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== inputValue) {
    t3 = inputValue.trim();
    $[4] = inputValue;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = t3.length > 0;
  let t5;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t4) {
    t5 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t4,
      staleTime: 900000
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return useQuery(t5);
}
export const getHighlightedTitle = (item: Item): string => {
  if (item.highlights?.[0]?.value) {
    return item.highlights[0].value;
  }
  if (item.highlight?.data?.title?.value) {
    return item.highlight.data.title.value;
  }
  return item.document.data.title;
};